export default "__VITE_ASSET__DmvdwWBU__"